'use client'
import { useState } from 'react'

export default function SubscribeButton({
  entityId,
  entityName,
}: {
  entityId: string
  entityName: string
}) {
  const [subscribed, setSubscribed] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')

  async function handleSubscribe() {
    const token = localStorage.getItem('token')
    if (!token) {
      window.location.href = '/login'
      return
    }
    setLoading(true)
    try {
      const res = await fetch('http://localhost:8001/api/subscriptions/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          entity_id: entityId,
          frequency: 'daily_digest'
        })
      })
      const data = await res.json()
      if (res.ok) {
        setSubscribed(true)
        setMessage('Daily digest activated')
      } else {
        setMessage(data.detail || 'Error')
      }
    } catch {
      setMessage('Error — try again')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="text-right">
      <button
        onClick={handleSubscribe}
        disabled={loading || subscribed}
        className={`px-4 py-2 text-[10px] tracking-[0.2em] uppercase border rounded transition ${
          subscribed
            ? 'border-green-500/40 text-green-400 bg-green-500/10'
            : 'border-blue-500/60 text-blue-300 hover:bg-blue-500/20 bg-blue-500/5'
        } disabled:opacity-50`}
      >
        {subscribed ? '✓ SUBSCRIBED' : loading ? 'SUBSCRIBING...' : '+ SUBSCRIBE'}
      </button>
      {message && (
        <p className="text-[9px] text-blue-400/40 mt-1 tracking-wider">{message}</p>
      )}
      {!subscribed && (
        <p className="text-[9px] text-blue-400/25 mt-1 tracking-wider">Daily email digest</p>
      )}
    </div>
  )
}